<script setup lang="ts">
import { RowInfo } from '@shared/ui/other'

import { useTutorKanbanExitDetails } from '../model/tutor-kanban-exit-details.hook'

defineOptions({
  name: 'TutorKanbanExitDetails',
})

const {
  isVisible,
  refExitRequestDate,
  refExitReason,
} = useTutorKanbanExitDetails()
</script>

<template>
  <template v-if="isVisible">
    <RowInfo
      title="Exit request date"
      :value="refExitRequestDate"
    />
    <RowInfo
      title="Tutor's exit reason"
      :value="refExitReason"
    />
  </template>
</template>
